import React, { useState } from 'react';
import bikesData from '../../Data/Bikes.json';
import ajsBikesData from '../../Data/AJSBikes.json';
import numberPlateData from '../../Data/NumberPlates.json';

import BikesTab from './BikesTab';
import NumberPlatesTab from './NumberPlatesTab';
import WDBikesTab from './WDBikesTab';
import './Bikes.css';

const BikesPage = () => {
  const [activeTab, setActiveTab] = useState('Matchless');
  const [bikes] = useState(bikesData || []);
  const [numberPlates] = useState(numberPlateData || []);

  const openTab = (tabName) => setActiveTab(tabName);

  return (
    <main className="bikes-page">
      <div className="bikes-page__frame">
        <section className="bikes-page__intro">
          <p className="bikes-page__eyebrow">Model Archive</p>
          <h1>AJS &amp; Matchless Bikes</h1>
          <p>
            Browse notable machines, wartime records and number plate references
            from the club archive.
          </p>
        </section>

        {/* LOCAL TABS JUST FOR BIKES PAGE */}
        <div className="bikes-tabs">
          <button
            type="button"
            className={
              'bikes-tab-button' +
              (activeTab === 'Matchless' ? ' active' : '')
            }
            onClick={() => openTab('Matchless')}
          >
            Matchless
          </button>

          <button
            type="button"
            className={
              'bikes-tab-button' +
              (activeTab === 'AJS' ? ' active' : '')
            }
            onClick={() => openTab('AJS')}
          >
            AJS
          </button>

          <button
            type="button"
            className={
              'bikes-tab-button' +
              (activeTab === 'WDBikes' ? ' active' : '')
            }
            onClick={() => openTab('WDBikes')}
          >
            WD Bikes
          </button>

          <button
            type="button"
            className={
              'bikes-tab-button' +
              (activeTab === 'Table' ? ' active' : '')
            }
            onClick={() => openTab('Table')}
          >
            Number Plates
          </button>
        </div>

        {/* TAB CONTENT */}
        <div className="bikes-page__tab-panel">
          {activeTab === 'Matchless' && <BikesTab bikes={bikes} />}
          {activeTab === 'AJS' && <BikesTab bikes={ajsBikesData} />}
          {activeTab === 'Table' && (
            <NumberPlatesTab numberPlates={numberPlates} />
          )}
          {activeTab === 'WDBikes' && (
            <WDBikesTab bikes={bikes.filter((bike) => bike.wd)} />
          )}
        </div>
      </div>
    </main>
  );
};

export default BikesPage;
